<template>
  <div class="container">
    <div class="restaurant">
      <div class="nav-container">
        <div class="d-flex align-center">
          <router-link to="/DeliveryZones">
            <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
          </router-link>

          <h1 class="page-title">{{ isEdit ? 'Редактировать зону доставки' : 'Создать зону доставки' }}</h1>
        </div>
        <div>
          <button @click="isEdit ? updateZone() : createZone()" class="btn-create" style="gap: 5px;">{{ isEdit ? 'Сохранить' : 'Создать' }} <svg width="15" height="11"
              viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9323 1.25L5.22396 9.95833L1.26562 6" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg></button>
        </div>

      </div>
      <div class="container-main">
        <div class="content-container">
          <div class="box-container">
            <h2 class="information-title">Информация</h2>

            <div class="horizontal-line"></div>

            <div class="col-content rest-name-container">
              <p class="col-title">Название<span class="red-dot">*</span></p>
              <input class="input-css" v-model="name" placeholder="---">
            </div>


            <div class="col-content desc-rest-container">
              <p class="col-title">Описание<span class="red-dot">*</span></p>
              <textarea class="input-css-textarea" v-model="description" placeholder="---"></textarea>
            </div>
            <div class="col-content minorder-container">
              <p class="col-title">Номер в списке<span class="red-dot">*</span></p>
              <input type="number" class="input-css" v-model="sortOrder" placeholder="---" />
            </div>
            <div class="col-content minorder-container">
              <p class="col-title">Стоимость доставки<span class="red-dot">*</span></p>
              <input type="text" class="input-css" :value="deliveryAmount !== null ? deliveryAmount.toLocaleString('ru-RU') : ''"
  @input="formatInput('deliveryAmount', $event)" placeholder="---" />
            </div>
            <div class="col-content minorder-container">
              <p class="col-title">Минимальная сумма заказа</p>
              <input type="text" class="input-css" :value="minOrderAmount !== null ? minOrderAmount.toLocaleString('ru-RU') : ''"
  @input="formatInput('minOrderAmount', $event)" placeholder="---" />
            </div>
            <div class="col-content minorder-container">
              <p class="col-title">Сумма для бесплатной доставки</p>
              <input type="text" class="input-css" :value="minOrderFreeAmount !== null ? minOrderFreeAmount.toLocaleString('ru-RU') : ''"
  @input="formatInput('minOrderFreeAmount', $event)" placeholder="---" />
            </div>
            <div class="col-content minorder-container">
              <p class="col-title">Время доставки(в минутах)<span class="red-dot">*</span></p>
              <input type="text" class="input-css" :value="deliveryTime !== null ? deliveryTime.toLocaleString('ru-RU') : ''"
  @input="formatInput('deliveryTime', $event)" placeholder="---" />
            </div>
            <!-- <div class="search-component">
              <p class="col-title">Сервис доставки <span class="red-dot">*</span></p>
              <v-autocomplete v-model="accountId" placeholder="---" :items="accounts" item-text="name" item-value="id"
                hide-details dense solo id="restaurant-selector" class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div>

            <div class="search-component">
              <p class="col-title">Выбор приложения <span class="red-dot">*</span></p>
              <v-autocomplete v-model="applicationId" placeholder="---" :items="applications" item-text="name"
                item-value="id" hide-details solo id="application-selector" class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div> -->
          </div>
        </div>
        <div class="integration-container">
            <div class="box-container">
            <h2 class="information-title">Интеграция Доставки</h2>

            <div class="horizontal-line"></div>
            <div class="search-component">
              <p class="col-title">Сервис доставки</p>
              <v-autocomplete v-model="deliveryServiceId" placeholder="---" :items="accounts" item-text="name" item-value="id"
                hide-details dense solo id="restaurant-selector" class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div class="col-content minorder-container">
              <p class="col-title">Процент к сумме доставки</p>
              <input type="number" class="input-css" v-model="deliveryPercent" placeholder="---" />
            </div>
            <div class="search-component">
              <p class="col-title">Класс курьера</p>

              <v-autocomplete
                v-model="taxiClass"
                :items="[
                  { name: 'Экспресс', id: 'express' },
                  { name: 'Курьер', id: 'courier' }
                ]"
                item-text="name"
                item-value="id"
                placeholder="---"
                hide-details
                dense
                solo
                id="taxi-class-selector"
                class="input-css"
              >
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { active: isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div>

            <div class="deliverty-title-margin">
              <p class="delivery-title">Использовать цену доставки</p>
            </div>
            <div class="d-flex align-center justify-space-between">
              <p class="delivery-text">{{
                useDeliveryPrice ? "Используется" : "Не используется"
              }}</p>
              <div class="">
                <input type="checkbox" hidden="hidden" id="priceDelivery" v-model="useDeliveryPrice" />
                <label class="switch" for="priceDelivery"></label>
              </div>
            </div>
                        <div class="deliverty-title-margin">
              <p class="delivery-title">ТермоСумка</p>
            </div>
            <div class="d-flex align-center justify-space-between">
              <p class="delivery-text">{{
                isRequireThermalBag ? "Используется" : "Не используется"
              }}</p>
              <div class="">
                <input type="checkbox" hidden="hidden" id="bag" v-model="isRequireThermalBag" />
                <label class="switch" for="bag"></label>
              </div>
            </div>
            <div class="deliverty-title-margin">
              <p class="delivery-title">АвтоКурьер</p>
            </div>
            <div class="d-flex align-center justify-space-between">
              <p class="delivery-text">{{
                isRequireAutoCourier ? "Используется" : "Не используется"
              }}</p>
              <div class="">
                <input type="checkbox" hidden="hidden" id="autoCouier" v-model="isRequireAutoCourier" />
                <label class="switch" for="autoCouier"></label>
              </div>
            </div>
                        <div class="deliverty-title-margin">
              <p class="delivery-title">Подверждение кодом</p>
            </div>
            <div class="d-flex align-center justify-space-between">
              <p class="delivery-text">{{
                isRequireCodeConfirmaion ? "Используется" : "Не используется"
              }}</p>
              <div class="">
                <input type="checkbox" hidden="hidden" id="codeConfirm" v-model="isRequireCodeConfirmaion" />
                <label class="switch" for="codeConfirm"></label>
              </div>
            </div>
            </div>
          </div>
      </div>
        <div class="map-container">
            <div class="box-container">
            <h2 class="information-title">Зона доставки</h2>
            <div class="horizontal-line"></div>
            <div style="position: relative;">
              <div id="map" style="width: 100%; height: 700px; border-radius: 10px; margin-bottom: 20px; margin-top: 20px;">
                    <div class="map-controls" :class="{ 'fullscreen-active': isFullscreen }">
                    <button class="btn-card" @click="startDrawing">Нарисовать зону</button>
                    <button class="btn-card" @click="finishDrawing">Закончить</button>
                    <button class="btn-card" @click="clearPolygon">Очистить карту</button>
                    <button class="btn-card" style="position: relative; overflow: hidden;">
                      <input type="file" @change="onFileUpload" accept=".kml,.kmz" style="opacity: 0; position:absolute; left:0; right:0; top:0; bottom:0; cursor:pointer;">
                      Загрузить KML
                    </button>
                  </div>
               </div>
            </div>
          </div>
          </div>
      <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
        {{ message }}
        <template v-slot:action="{ attrs }">
          <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
            Закрыть
          </div>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>


<style scoped>
/* Когда карта в fullscreen — задаём подложку */
#map {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  position: relative; /* нужно, чтобы кнопки позиционировались внутри */
  overflow: hidden;
}

.map-controls {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  z-index: 1000; /* повыше чем у карты */
  pointer-events: auto; /* важно — чтобы клики работали */
}
.btn-card {
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;

}
input[type="number"] {
  -moz-appearance: textfield;
  /* Убирает стрелочки в Firefox */
  -webkit-appearance: none;
  /* Убирает стрелочки в Chrome, Safari */
  appearance: none;
  /* Для совместимости */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  /* Убирает стрелочки в Chrome, Safari */
  margin: 0;
  /* Убирает лишние отступы */
}

.snackbar-btn {
  color: var(--Red, #eb5757);
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.25rem;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
  cursor: pointer;
}

.restaurant-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.restaurant-item :first-child {
  /* padding-left: 10px; */
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.deliverty-title-margin {
  margin-top: 29.5px;
}

.loyal-margin {
  margin-top: 29.5px;
}

.delivery-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 15px;
  color: #606c80;
  margin-bottom: 0px;
}

.delivery-title {
  margin-bottom: 0px;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
}

.switch {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 25px;
  border-radius: 20px;
  background: #eaeaea;
  transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  cursor: pointer;
}

.switch::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fafafa;
  border-radius: 50%;
  transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(128, 128, 128, 0.1);
}

input:checked+.switch {
  background: #72da67;
}

input:checked+.switch::before {
  left: 27px;
  background: #fff;
}

input:checked+.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(0, 150, 136, 0.2);
}

.minorder-container {
  margin-top: 23.5px;
}

.search-component {
  margin-top: 11.5px;
}

.adress-container {
  margin-top: 23.5px;
}

.phonenumber-container {
  margin-top: 23.5px;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  border: 1px solid transparent !important;
}

.desc-rest-container {
  margin-top: 14px;
}

.rest-name-container {
  margin-top: 17px;
}

.input-css {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  /* height: 42px; */
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;

}

.input-css-textarea {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  height: 72px;
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
  resize: none;
}

.input-css-textarea:hover,
.input-css-textarea:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.input-css:hover,
.input-css:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.box-container {
  padding: 18px 18px;
}

.btn-create {
  /* width: 121px; */
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;

}

.page-title {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  color: #323c4d;
}

.work-margin-bot {
  margin-bottom: 50px;
}

.col-title-work {
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0px;
}


.special-border:focus {
  border-radius: 3px;
  border: 2px solid var(--03, black);
  background: var(--white, #fff);
  width: 295px;
  height: 37px;
  padding-left: 10px;
}

.special-border {
  border-radius: 3px;
  border: 1px solid var(--03, #c1c1c1);
  background: var(--white, #fff);
  width: 295px;
  height: 37px;
  padding-left: 10px;
}

.time-end {
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 146.667% */
}

.time-start {
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 146.667% */
}

.end-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.start-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 21px;
}

.work-img-margin {
  margin-right: 21px;
}

.work-1 {
  text-align: end;
}

.dot-work {
  margin-left: 69px;
}

.work-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-container {
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 17px;
}

.img-pluss-btn {
  cursor: pointer;
  height: 100%;
  display: flex;
  margin-right: 17px;
}

.nav-container {
  /* border-right: 1px solid var(--04, #eaeaea); */
  /* width: 56px; */
  position: sticky;
  top: 7%;
  z-index: 6;
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
  padding: 15px 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* .top-panel .container {
    width: 100%;
    padding: 0px !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  } */
.vertical-line {
  width: 1px;
  height: 42px;
  background: #e0e0e0;
  margin-left: 31px;
}

.vertical-line-1 {
  width: 1px;
  height: 50px;
  background: #e0e0e0;
}

.add-btn .add-text {
  color: var(--01, #333);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-left: 12px;
  transition: color 0.3s ease;
}

.add-btn:hover .add-text {
  /* Цвет текста при наведении */
  color: black;
  /* Замените "red" на желаемый цвет текста */
  font-weight: 500;
  font-size: 17px;
}

.add-btn {
  display: flex;
  align-items: center;
  padding: 12px 0px;
  margin-left: 37px;
  cursor: pointer;
}

.top-panel {
  border-bottom: 1px solid var(--04, #eaeaea);
  background: var(--white, #fff);
  height: 50px;
  display: flex;
  align-items: center;
}






.requisites-text-container {
  display: flex !important;
  flex-direction: row;
  /* justify-content: space-evenly; */
  align-items: baseline;
}

.requisites-title {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 227px;
}

.margin-logo-divider {
  margin-bottom: 48px;
}

.logo-dot-3 {
  margin-right: 13px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.logo-dot-2 {
  margin-right: 16px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.logo-dot {
  margin-right: 69px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-file-upload {
  cursor: pointer;
}

.logo-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.uploaded-image-logo {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.uploaded-image-header {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.uploaded-image-photo-rest {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.work-margin-img {
  margin-bottom: 15px;
}

.work-img {
  width: 22px;
  height: 22px;
}

.col-img {
  flex-direction: column-reverse;
  display: flex;
}

.work-margin {
  padding-bottom: 15px;
}

.horizontal-line {
  height: 1px;
  background: #d4d4e1;
  margin-top: 5px;

}

.tel-pointer {
  cursor: pointer;
}

.col-paddings-r-l {
  padding-right: 0px;
  padding-left: 0px;
}

.col-paddings-t-b {
  padding-top: 0px;
  padding-bottom: 0px;
}

.col-content {
  display: flex;
  flex-direction: column;
}



.red-dot {
  color: #e41313;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.col-title {
  color: #323c4d;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.information-title {
  font-family: Inter;
  font-style: normal;
  line-height: normal;
  font-weight: 700;
  font-size: 20px;
  color: #323c4d;
}
.container-main {
    display: flex;
    flex-direction: row;
    gap: 30px
}
.content-container {
  border-radius: 8px;
  background: var(--white, #fff);
  margin-top: 16px;
  width: 100%;
  max-width: 533px;
}
.integration-container {
  border-radius: 8px;
  background: var(--white, #fff);
  margin-top: 16px;
  width: 100%;
  max-width: 533px;
  height: 100%;
}
.map-container {
          border-radius: 8px;
  background: var(--white, #fff);
  margin-top: 16px;
  width: 100%;
}
::v-deep .v-autocomplete.v-input--outlined .v-input__control {
  border: none !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border: none;
}

::v-deep .v-select__slot {
  border: none;
}
::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
    border-bottom: 0.5px solid rgb(212, 212, 225);
}

@media (max-width: 1069px) {
  .page-title {
    font-family: Inter;
    font-weight: 700;
    font-size: 19px;
    color: #323c4d;
    line-height: normal;
  }

  .nav-container {
    margin-top: 24px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
export default {
  name: "CreateDeliveryZone",
  directives: { mask },
  props: {
    requestData: {},
    responseData: {},
  },
  data() {
    return {
      map: null,
      polygon: null,
      points: [],
      deliveryPrice: 0,
      snackbar: false,
      message: "",
      selectedImage: null,
      uploadedImageLogo: "",
      uploadedImageHeader: "",
      uploadedImagePhotoRest: "",
      minOrder: "",
      commisionFromOrder: "",
      isEdit: false,
      restaurantId: "",
      name: "",
      description: "",
      sortOrder: null,
      deliveryAmount: null,
      minOrderAmount: null,
      minOrderFreeAmount: null,
      deliveryTime: null,
      deliveryPercent: null,
      taxiClass: "",
      deliveryServiceId: null,
      useDeliveryPrice: false,
      isRequireThermalBag: false,
      isRequireAutoCourier: false,
      isRequireCodeConfirmaion: false,
      zoneId: "",
      latitude: "",
      longitude: "",
      orderRestinApp: "",
      address: "",
      phoneNumber: "",
      instagram: "",
      isUsingDelivery: true,
      isUsingBonus: true,
      accountId: "",
      applicationId: "",
      newRest: {
      },
      currentAcc: "",
      accounts: [],
      applications: [],
      currentPage: 0,
      totalPages: 0,
      totalItems: 0,
    };
  },
  async mounted() {
    const { restaurantId, zoneId } = this.$route.query
    await this.initMap();
    if (zoneId) {
      // режим редактирования
      this.isEdit = true;
      this.zoneId = zoneId;
      this.restaurantId = restaurantId
      await this.getZoneData(zoneId)
      // await this.accountList();
    } else if (restaurantId) {
      // режим создания
      console.log(restaurantId);
      this.restaurantId = restaurantId
       await this.accountList();
    }
  },
  beforeDestroy() {
  // document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
},
  methods: {
    validateInput() {
      // --- для minOrderAmount ---
      this.minOrderAmount = this.minOrderAmount.replace(/\D/g, "");
      if (this.minOrderAmount) {
        this.minOrderAmount = Number(this.minOrderAmount).toLocaleString("ru-RU");
      }

      // --- для latitude ---
      if (this.latitude !== undefined && this.latitude !== null) {
        let lat = this.latitude.toString().replace(/[^0-9.]/g, "");
        const latParts = lat.split(".");
        if (latParts.length > 2) {
          lat = latParts[0] + "." + latParts.slice(1).join("");
        }
        this.latitude = lat ? Number(lat) : null;  // <-- число
      }

      // --- для longitude ---
      if (this.longitude !== undefined && this.longitude !== null) {
        let lng = this.longitude.toString().replace(/[^0-9.]/g, "");
        const lngParts = lng.split(".");
        if (lngParts.length > 2) {
          lng = lngParts[0] + "." + lngParts.slice(1).join("");
        }
        this.longitude = lng ? Number(lng) : null; // <-- число
      }
    },
    formatPhone() {
      if (this.phoneNumber === "7") {
        this.phoneNumber = "+7 (7"; // Автоматически добавляем второй 7
      }
    },

    uploadImageLogo(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageLogo = URL.createObjectURL(file);
      }
    },
    uploadImageHeader(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageHeader = URL.createObjectURL(file);
      }
    },
    uploadImagePhotoRest(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImagePhotoRest = URL.createObjectURL(file);
      }
    },
    createRestbtn() {
      this.createNewRest();
    },
    async initMap() {
      // Инициализация карты
      ymaps.ready(() => {
        this.map = new ymaps.Map("map", {
          center: [43.238949, 76.889709], // Алматы
          zoom: 12,
          controls: ["zoomControl", "typeSelector","fullscreenControl"],
        });
        // const fullscreenControl = new ymaps.control.FullscreenControl({
        //   options: { position: { top: 10, right: 100 } },
        // });
        // this.map.controls.add(fullscreenControl);
        // Добавление инструмента рисования полигона
        // const drawButton = new ymaps.control.Button({
        //   data: { content: "Нарисовать зону" },
        //   options: { selectOnClick: false },
        // });

        // drawButton.events.add("click", () => {
        //   const polygon = new ymaps.Polygon([], {}, {
        //     editorDrawingCursor: "crosshair",
        //     fillColor: "#00FF0022",
        //     strokeColor: "#0000FF",
        //     strokeWidth: 2,
        //   });

        //   this.map.geoObjects.add(polygon);
        //   polygon.editor.startDrawing();

        //   polygon.events.add("editorstatechange", () => {
        //     if (!polygon.editor.state.get("drawing")) {
        //       this.polygon = polygon;
        //       this.points = polygon.geometry.getCoordinates()[0]; // <-- массив [ [lat, lon], ... ]
        //       console.log("Точки зоны:", this.points);
        //     }
        //   });
        // });

        // this.map.controls.add(drawButton, { float: "right" });
      });
    },
    startDrawing() {
    if (!this.map) return;

    // Удаляем старый полигон если был
    if (this.polygon) {
      this.map.geoObjects.remove(this.polygon);
      this.polygon = null;
    }

    this.polygon = new ymaps.Polygon([], {}, {
      editorDrawingCursor: "crosshair",
      fillColor: "#00FF0022",
      strokeColor: "#0000FF",
      strokeWidth: 2,
    });

    this.map.geoObjects.add(this.polygon);
    this.polygon.editor.startDrawing();
    this.drawing = true;
  },

  finishDrawing() {
    if (this.polygon && this.drawing) {
      this.polygon.editor.stopDrawing();
      this.points = this.polygon.geometry.getCoordinates()[0];
      console.log("📍 Точки зоны:", this.points);
      this.drawing = false;
    } else {
      this.snackbar = true;
      this.message = "Не выбрана активная зона";
    }
  },
   clearPolygon() {
    if (this.polygon) {
      this.map.geoObjects.remove(this.polygon);
      this.polygon = null;
      this.points = [];
      this.drawing = false;
    }
  },
    async createZone() {
      if (!this.points.length) {
        this.snackbar = true;
        this.message = "Сначала нарисуйте зону на карте!";
        return;
      }
      // console.lig("ALI", this.points);
      // Преобразуем координаты в формат [longitude, latitude]
      const formattedPoints = this.points.map(([lat, lon]) => [lon, lat]);
      const area = formattedPoints.reduce((sum, [x1, y1], i, arr) => {
      const [x2, y2] = arr[(i + 1) % arr.length];
      return sum + (x1 * y2 - x2 * y1);
    }, 0);

    // Если площадь положительная — значит полигон по часовой, надо развернуть
    if (area > 0) {
      formattedPoints.reverse();
    }

      const payload = {
        restaurantId: this.restaurantId,
        name: this.name,
        sortOrder: this.sortOrder,
        description: this.description,
        deliveryPrice: this.deliveryAmount,
        minOrderAmount:this.minOrderAmount,
        freeDeliveryAmount: this.minOrderFreeAmount,
        estimatedDeliveryMin: this.deliveryTime,
        useDeliveryPrice: this.useDeliveryPrice,
        deliveryPriceAddPercent: this.deliveryPercent,
        taxiClass: this.taxiClass,
        isRequireThermalBag: this.isRequireThermalBag,
        isRequireAutoCourier: this.isRequireAutoCourier,
        isRequireCodeConfirmaion: this.isRequireCodeConfirmaion,
        restaurantDeliveryExternalServiceId: this.deliveryServiceId,
        points: formattedPoints,
      };
      if (!this.name || this.name.trim() === '') {
        this.snackbar = true;
        this.message = "Название зоны доставки обязательно для заполнения";
        return;
      }
      if (!this.description || this.description.trim() === '') {
        this.snackbar = true;
        this.message = "Описание зоны доставки обязательно для заполнения";
        return;
      }
      if (!this.sortOrder || this.sortOrder === '') {
        this.snackbar = true;
        this.message = "Номер в списке обязателен для заполнения";
        return;
      }
      if (!this.deliveryAmount || this.deliveryAmount === '') {
        this.snackbar = true;
        this.message = "Цена доставки обязательна для заполнения";
        return;
      }
      if (!this.deliveryTime || this.deliveryTime === '') {
        this.snackbar = true;
        this.message = "Время доставки обязательна для заполнения";
        return;
      }
      try {
        const res = await this.$http.post("/api/RestaurantDeliveryZone", payload);
        console.log("✅ Зона доставки создана:", res.data);
          this.snackbar = true;
          this.message = "Зона доставки успешно создана";
          this.drawCreatedZone(formattedPoints);
          if (res.status === 200 || res.status === 201) {
             setTimeout(() => {
            this.$router.push('/DeliveryZones'); 
          }, 2000);
           }
      } catch (err) {
          this.snackbar = true;
          this.message = "Ошибка при создании зоны доставки";
      }
    },
    drawEditablePolygon(points) {
    if (!this.map) return;

    const polygon = new ymaps.Polygon(
        [points],
        {},
        {
        fillColor: "#00FF0044",
        strokeColor: "#008000",
        strokeWidth: 2,
        interactivityModel: 'default#transparent', // чтобы можно было кликать
        }
    );

    this.map.geoObjects.add(polygon);
    this.polygon = polygon;

    // Подгоняем карту под границы полигона
    this.map.setBounds(polygon.geometry.getBounds(), { checkZoomRange: true });

    // Позволяем включать редактирование по клику
    polygon.events.add("click", () => {
        if (polygon.editor.state.get("editing")) {
        polygon.editor.stopEditing();
        } else {
        polygon.editor.startEditing();
        }
    });
    },

    drawCreatedZone(points) {
      const polygon = new ymaps.Polygon(
        [points.map(([lon, lat]) => [lat, lon])],
        {},
        { fillColor: "#00FF0044", strokeColor: "#008000", strokeWidth: 2 }
      );
      this.map.geoObjects.add(polygon);
      this.map.setBounds(polygon.geometry.getBounds(), { checkZoomRange: true });
    },
    createNewRest() {
      this.newRest.name = this.name || null;
      this.newRest.latitude = this.latitude || null;
      this.newRest.longitude = this.longitude || null;
      this.newRest.description = this.description || null;
      this.newRest.accountId = this.accountId || null;
      this.newRest.phoneNumber = this.phoneNumber || null;
      this.newRest.applicationId = this.applicationId || null;
      this.newRest.address = this.address || null;
      this.newRest.minOrderAmount = this.minOrderAmount || null;
      this.newRest.isUsingDelivery = this.isUsingDelivery;
      this.newRest.isUsingBonus = this.isUsingBonus;
      if (!this.name || this.name.trim() === '') {
        this.snackbar = true;
        this.message = "Название ресторана обязательно для заполнения";
        return;
      }
      if (!this.latitude || this.latitude.trim() === '') {
        this.snackbar = true;
        this.message = "Ширина ресторана обязательно для заполнения";
        return;
      }
      if (!this.longitude || this.longitude.trim() === '') {
        this.snackbar = true;
        this.message = "Долгота ресторана обязательна для заполнения";
        return;
      }
      if (!this.description || this.description.trim() === '') {
        this.snackbar = true;
        this.message = "Описание ресторана обязательно для заполнения";
        return;
      }
      if (!this.address || this.address.trim() === '') {
        this.snackbar = true;
        this.message = "Адрес ресторана обязателен для заполнения";
        return;
      }
      if (!this.minOrderAmount || this.minOrderAmount === '') {
        this.snackbar = true;
        this.message = "Минимальная сумма заказа обязательна для заполнения";
        return;
      }
      if (!this.phoneNumber || this.phoneNumber.trim() === '') {
        this.snackbar = true;
        this.message = "Номер телефона для связи клиентов обязателен для заполнения";
        return;
      }
      if (!this.accountId || this.accountId === null) {
        this.snackbar = true;
        this.message = "Юр лицо обязателен для заполнения";
        return;
      }
      if (!this.applicationId || this.applicationId === null) {
        this.snackbar = true;
        this.message = "Приложение обязателено для заполнения";
        return;
      }
      this.$http
        .post("/api/Restaurant", this.newRest)
        .then(() => {
          // this.$router.push({ path: `/RestaurantRoot/` });
          // this.initialize();
          // this.dialogCreate = false;
          // this.newAcc = {
          //   name: "",
          //   bin: "",
          //   bic: "",
          //   legalAddress: ""
          // };
          this.snackbar = true;
          this.message = "Ресторан успешно создан"
          setTimeout(() => {
            this.$router.push({ path: `/RestaurantRoot/` });
          }, 3000);
        })
        .catch((error) => {
          //alert(error);
          this.snackbar = true;
          if (error.response && error.response.status === 400) {
            this.message = "Заполните данные";
          } else {
            this.message = "Не удалось создать ресторан";
          }
        });
    },
async onFileUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const kmlText = e.target.result;
    const polygons = this.parseKml(kmlText);

    // Удаляем старый полигон если есть
    if (this.polygon) {
      this.map.geoObjects.remove(this.polygon);
      this.polygon = null;
      this.points = [];
    }

    // Берём первый полигон из KML (или можно пройтись по всем, если нужно)
    if (polygons.length > 0) {
      this.drawEditablePolygon1(polygons[0]); // делаем редактируемым
      this.points = polygons[0]; // сохраняем точки
      this.drawing = false;
    }
  };
  reader.readAsText(file);
},

parseKml(kmlText) {
  const parser = new DOMParser();
  const xml = parser.parseFromString(kmlText, "text/xml");
  const polygons = [];

  const polyNodes = xml.getElementsByTagName("Polygon");

  for (let poly of polyNodes) {
    const outer = poly.getElementsByTagName("outerBoundaryIs")[0];
    if (!outer) continue;

    const ring = outer.getElementsByTagName("LinearRing")[0];
    if (!ring) continue;

    const coordsNode = ring.getElementsByTagName("coordinates")[0];
    if (!coordsNode) continue;

    const coordsText = coordsNode.textContent.trim();

    const coords = coordsText.split(/\s+/).map(pair => {
      const [lon, lat] = pair.split(",").map(Number);
      return [lat, lon]; // для Яндекс карт
    });

    polygons.push(coords);
  }

  return polygons;
},

drawEditablePolygon1(coords) {
  if (!this.map) return;

  // Создаём полигон
  const polygon = new ymaps.Polygon([coords], {}, {
    fillColor: "#00FF0044",
    strokeColor: "#008000",
    strokeWidth: 2,
    interactivityModel: 'default#transparent', // чтобы можно кликать
  });

  this.map.geoObjects.add(polygon);
  this.polygon = polygon;

  // Подгоняем карту под полигон
  this.map.setBounds(polygon.geometry.getBounds(), { checkZoomRange: true });

  // Включаем редактирование по клику
  polygon.events.add("click", () => {
    if (polygon.editor.state.get("editing")) {
      polygon.editor.stopEditing();
      this.points = polygon.geometry.getCoordinates()[0]; // обновляем точки
    } else {
      polygon.editor.startEditing();
    }
  });

  // Если сразу нужно редактирование:
  polygon.editor.startEditing();
},
addPolygonToMap(coords) {
    // если coords это массив массивов — значит всё ок
  // если coords[0] это число — это нормальный полигон
  // если coords[0] это массив — значит нужно раскрыть
  if (Array.isArray(coords[0][0])) {
    // coords = [[lat, lon], [lat, lon]] внутри массива — берем как полигон
    coords.forEach(subCoords => {
      this.addPolygonToMap(subCoords);
    });
    return;
  }

  const polygon = new ymaps.Polygon([coords], {}, {
    fillColor: "#00FF0044",
    strokeColor: "#0000FF",
    strokeWidth: 3
  });

  this.map.geoObjects.add(polygon);

  // Масштаб под зону
  this.map.setBounds(polygon.geometry.getBounds(), {
    checkZoomRange: true,
  });
},
    accountList() {
      this.$http
        .put("/api/AccountDeliveryExternalService/PagedList", {
          pageNumber: 1,
          pageSize: 1000,
        //   filters: [
        //     {
        //       property: "RestaurantId",
        //       operator: "eq",
        //       value: this.restaurantId,
        //     },
        // ],
          headers: {
            'Content-Type': 'application/json',
          }
        },
        {
        params: {
          restaurantId: this.restaurantId,
        },
    })
        .then((response) => {
          // Предполагается, что `response.data.items` содержит массив объектов
          this.accounts = response.data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.name || "Не указано", // Название аккаунта

          }));
          // Устанавливаем общее количество элементов и проверяем наличие данных
          this.totalItems = response.data.totalCount;
          this.showNoDataMessage = this.totalItems === 0;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    appList() {
      this.$http
        .put("/api/Application/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
          //             filters: [
          //   {
          //     property: "Name",
          //     operator: "contains",
          //     value: this.search.toLowerCase(),
          //   }
          // ],
        })
        .then((response) => {
          this.applications = response.data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.brandName || "Не указано", // Название аккаунта

          }));
          //this.totalPages = response.data.totalPages; // Общее количество страниц
          this.totalItems = response.data.totalCount;
          this.showNoDataMessage = this.totalItems === 0;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    formatInput(field, event) {
    // берём сырое значение
    let value = event.target.value.replace(/\D/g, '');

    // сохраняем в переменную как number
    this[field] = value ? Number(value) : null;

    // отображаем красиво
    event.target.value = value ? Number(value).toLocaleString('ru-RU') : '';
  },
    async getZoneData(zoneId) {
        try {
            const { data } = await this.$http.get(`/api/RestaurantDeliveryZone/${zoneId}`);

            // Заполняем форму
            this.name = data.name;
            this.sortOrder = data.sortOrder;
            this.description = data.description;
            this.deliveryAmount = data.deliveryPrice;
            this.minOrderAmount = data.minOrderAmount;
            this.minOrderFreeAmount = data.freeDeliveryAmount;
            this.deliveryTime = data.estimatedDeliveryMin;
            this.deliveryPercent = data.deliveryPriceAddPercent;
            this.taxiClass = data.taxiClass;
            this.useDeliveryPrice = data.useDeliveryPrice;
            this.isRequireThermalBag = data.isRequireThermalBag;
            this.isRequireAutoCourier = data.isRequireAutoCourier;
            this.isRequireCodeConfirmaion = data.isRequireCodeConfirmaion;
            this.restaurantId = data.restaurantId;
            this.deliveryServiceId = data.restaurantDeliveryExternalServiceId;
            this.accountList();
            // Отрисовка зоны на карте
            this.points = data.points.map(([lat, lon]) => [lat, lon]);
            console.log("This", this.points);
             setTimeout(() => {
                if (this.map) {
                    this.drawEditablePolygon(this.points);
                } else {
                    this.snackbar = true;
                    this.message = "Карта ещё не инициализирована"
                }
                }, 300);
        } catch (err) {
            this.snackbar = true;
            this.message = "Ошибка при загрузке зоны";
        }
        },
        async updateZone() {
    if (!this.polygon) return;

    const points = this.polygon.geometry.getCoordinates()[0];
    const formattedPoints = points.map(([lat, lon]) => [lon, lat]);

    const payload = {
      id: this.zoneId,
      name: this.name,
      description: this.description,
      sortOrder: this.sortOrder,
      deliveryPrice: this.deliveryAmount,
      minOrderAmount: this.minOrderAmount,
      freeDeliveryAmount: this.minOrderFreeAmount,
      estimatedDeliveryMin: this.deliveryTime,
      useDeliveryPrice: this.useDeliveryPrice,
      deliveryPriceAddPercent:this.deliveryPercent,
      taxiClass: this.taxiClass,
      isRequireThermalBag: this.isRequireThermalBag,
      isRequireAutoCourier: this.isRequireAutoCourier,
      isRequireCodeConfirmaion: this.isRequireCodeConfirmaion,
      restaurantDeliveryExternalServiceId: this.deliveryServiceId,
      points: formattedPoints,
    };

    try {
      const res = await this.$http.put(`/api/RestaurantDeliveryZone/${this.zoneId}`, payload);
      console.log("✅ Зона обновлена:", res.data);
      this.snackbar = true;
      this.message = "Зона доставки успешно обновлена";
    } catch (err) {
      this.snackbar = true;
      this.message = "Ошибка при обновлении зоны доставки";
    }
},
  },
  created() {
    // this.accountList();
    // this.appList();

  },

  watch: {

  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>





<style lang="scss">
@media (min-width: 1264px) {
  .container {
    //1185px дефолтное название если что то ломаться начнется на маленьких мониторах
    max-width: 100% !important;
  }
}



@media (min-width: 960px) {

  //900 дефолтное название если что то ломаться начнется на маленьких мониторах
  .container {
    max-width: 100% !important;
  }
}
</style>